import { db } from '../config/firebase';
import {
  collection, doc, getDocs, updateDoc, deleteDoc, setDoc,
  query, where, Timestamp,
} from 'firebase/firestore';
import { MapArea, MapPin } from '../types/maps.types';

const AREAS = 'mapAreas';
const PINS = 'mapPins';

export const mapToolsService = {
  // ---- Areas (polygons) ---------------------------------------------------
  async getAreas(projectId: string): Promise<MapArea[]> {
    const q = query(collection(db, AREAS), where('projectId', '==', projectId));
    const snap = await getDocs(q);
    return snap.docs.map(d => ({ id: d.id, ...d.data() } as MapArea));
  },

  async createArea(data: Omit<MapArea, 'id' | 'createdAt' | 'updatedAt'>): Promise<string> {
    const ref = doc(collection(db, AREAS));
    const clean = Object.fromEntries(Object.entries(data).filter(([, v]) => v !== undefined));
    await setDoc(ref, {
      ...clean,
      id: ref.id,
      createdAt: Timestamp.now(),
      updatedAt: Timestamp.now(),
    });
    return ref.id;
  },

  async updateArea(id: string, updates: Partial<MapArea>): Promise<void> {
    await updateDoc(doc(db, AREAS, id), { ...updates, updatedAt: Timestamp.now() });
  },

  async deleteArea(id: string): Promise<void> {
    await deleteDoc(doc(db, AREAS, id));
  },

  // ---- Pins (points of interest) ------------------------------------------
  async getPins(projectId: string): Promise<MapPin[]> {
    const q = query(collection(db, PINS), where('projectId', '==', projectId));
    const snap = await getDocs(q);
    return snap.docs.map(d => ({ id: d.id, ...d.data() } as MapPin));
  },

  async createPin(data: Omit<MapPin, 'id' | 'createdAt' | 'updatedAt'>): Promise<string> {
    const ref = doc(collection(db, PINS));
    const clean = Object.fromEntries(Object.entries(data).filter(([, v]) => v !== undefined));
    await setDoc(ref, {
      ...clean,
      id: ref.id,
      createdAt: Timestamp.now(),
      updatedAt: Timestamp.now(),
    });
    return ref.id;
  },

  async updatePin(id: string, updates: Partial<MapPin>): Promise<void> {
    await updateDoc(doc(db, PINS, id), { ...updates, updatedAt: Timestamp.now() });
  },

  async deletePin(id: string): Promise<void> {
    await deleteDoc(doc(db, PINS, id));
  },
};
